import { TrustPilotLogoIcon } from "styles/icons";
import { ChakraFlex as Flex, ChakraHStack as HStack } from "@airhelp/react-ui-components";
import type { StarsProps } from "./ReviewCard.d";

const star = (key) => (
  <Flex bg="success.500" key={key}>
    <TrustPilotLogoIcon color="white" m={0.5} />
  </Flex>
);

export const Stars = ({ amount = 5 }: StarsProps) => {
  const stars = [...Array(amount)].map((e, i) => star(i));

  return <HStack spacing={1}>{stars}</HStack>;
};
